/* LEHUA · Cart Drawer Recommendations
   Quando cart drawer abre, fetch produtos relacionados ao último item
   e injeta bloco "Você esqueceu" abaixo dos itens. */

(function () {
  'use strict';

  const LIMIT = 3;
  let injected = false;

  function fmtMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function buildCard(product) {
    const img = product.featured_image || (product.images && product.images[0]) || '';
    const imgSrc = typeof img === 'string' ? img : (img && img.src) || '';
    const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
    return (
      '<div class="lehua-cart-recs__card" data-variant-id="' + (variantId || '') + '">' +
        '<a class="lehua-cart-recs__link" href="' + product.url + '" aria-label="' + product.title.replace(/"/g, '&quot;') + '">' +
          (imgSrc ? '<img class="lehua-cart-recs__img" src="' + imgSrc + '" alt="" loading="lazy">' : '<div class="lehua-cart-recs__img"></div>') +
          '<div class="lehua-cart-recs__info">' +
            '<div class="lehua-cart-recs__name">' + product.title + '</div>' +
            '<div class="lehua-cart-recs__price">' + fmtMoney(product.price) + '</div>' +
          '</div>' +
        '</a>' +
        (variantId ? '<button type="button" class="lehua-cart-recs__add" data-add-variant="' + variantId + '" aria-label="Adicionar ' + product.title.replace(/"/g, '&quot;') + '">+</button>' : '') +
      '</div>'
    );
  }

  function findInsertionPoint(drawer) {
    return drawer.querySelector('.cart-drawer__content') ||
           drawer.querySelector('.cart-drawer__dialog') ||
           drawer;
  }

  function insertBlock(drawer, productsHTML) {
    const old = drawer.querySelector('[data-lehua-cart-recs]');
    if (old) old.remove();
    const wrap = document.createElement('div');
    wrap.setAttribute('data-lehua-cart-recs', '');
    wrap.className = 'lehua-cart-recs';
    wrap.innerHTML =
      '<div class="lehua-cart-recs__heading">Você esqueceu</div>' +
      '<div class="lehua-cart-recs__list">' + productsHTML + '</div>';
    const target = findInsertionPoint(drawer);
    if (target) target.appendChild(wrap);

    // Bind add buttons
    wrap.querySelectorAll('[data-add-variant]').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const id = btn.dataset.addVariant;
        if (!id) return;
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = '✓';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }),
        })
        .then(r => r.json())
        .then(() => {
          // Notify cart drawer to refresh
          document.dispatchEvent(new CustomEvent('cart:item:added'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
        })
        .catch(() => { btn.textContent = original; btn.disabled = false; });
      });
    });
  }

  function loadRecommendations() {
    const drawer = document.querySelector('cart-drawer-component, .cart-drawer');
    if (!drawer) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(cart => {
        if (!cart || !cart.items || !cart.items.length) {
          const old = drawer.querySelector('[data-lehua-cart-recs]');
          if (old) old.remove();
          return;
        }
        const lastItem = cart.items[cart.items.length - 1];
        const productId = lastItem.product_id;
        return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + LIMIT + '&intent=related')
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            if (!data || !data.products || !data.products.length) return;
            // Filter out products already in cart
            const cartProductIds = cart.items.map(i => i.product_id);
            const filtered = data.products.filter(p => !cartProductIds.includes(p.id));
            if (!filtered.length) return;
            const html = filtered.slice(0, LIMIT).map(buildCard).join('');
            insertBlock(drawer, html);
          });
      })
      .catch(err => console.warn('Lehua cart recs failed:', err));
  }

  // Trigger when cart drawer opens
  document.addEventListener('click', e => {
    const t = e.target.closest('[href="/cart"], [data-action="open-cart-drawer"], .header__icon--cart, .cart-icon');
    if (t) setTimeout(loadRecommendations, 350);
  }, true);

  document.addEventListener('cart:updated', () => setTimeout(loadRecommendations, 200));
  document.addEventListener('cart:refresh', () => setTimeout(loadRecommendations, 200));
  document.addEventListener('cart:item:added', () => setTimeout(loadRecommendations, 400));

  // Observe cart drawer dialog open
  if (window.MutationObserver) {
    const observer = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === 'open' || (m.attributeName === 'aria-hidden' && m.target.getAttribute('aria-hidden') === 'false')) {
          setTimeout(loadRecommendations, 250);
        }
      });
    });
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('cart-drawer-component, .cart-drawer__dialog').forEach(el => {
        observer.observe(el, { attributes: true });
      });
    });
  }

  // Initial load if cart drawer already open (page load with items)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(loadRecommendations, 800));
  } else {
    setTimeout(loadRecommendations, 800);
  }
})();
